import { designToken, quickProperty } from '../component-tokens';
const baseDefault = {
    height: quickProperty('20px'),
    padding: quickProperty('0 var(--goto-spacing-02)'),
    font: designToken('caption-default-02'),
    color: designToken('text-02'),
    display: quickProperty('inline-flex'),
    'align-items': quickProperty('center'),
    'background-color': designToken('neutral-03'),
    'border-radius': quickProperty('10px'),
    'white-space': quickProperty('nowrap'),
};
const badgeCounterDefault = {
    'border-radius': quickProperty('12px'),
    font: designToken('button-text-small'),
    display: quickProperty('inline-grid'),
    'place-items': quickProperty('center'),
    'min-height': quickProperty('20px'),
    'min-width': quickProperty('20px'),
    padding: quickProperty('0 6.5px'),
    'word-break': quickProperty('normal'),
};
export const badgeTokens = {
    tag: 'chameleon-badge',
    name: 'badge',
    reactImports: 'Badge',
    sizes: [
        {
            name: 'small',
            attributes: {
                height: quickProperty('16px'),
                'min-height': quickProperty('16px'),
                'min-width': quickProperty('16px'),
                padding: quickProperty('0 var(--goto-spacing-01)'),
                'font-size': quickProperty('10px'),
                'line-height': quickProperty('16px'),
            },
        },
        {
            name: 'medium',
            attributes: Object.assign({}, baseDefault),
        },
    ],
    variants: [
        {
            name: 'default',
            attributes: Object.assign({}, baseDefault),
        },
        {
            name: 'info',
            attributes: Object.assign(Object.assign({}, baseDefault), { color: designToken('link'), 'background-color': designToken('information-03') }),
        },
        {
            name: 'success',
            attributes: Object.assign(Object.assign({}, baseDefault), { color: designToken('text-success-02'), 'background-color': designToken('success-03') }),
        },
        {
            name: 'danger',
            attributes: Object.assign(Object.assign({}, baseDefault), { color: designToken('text-error-02'), 'background-color': designToken('danger-03') }),
        },
        {
            name: 'warning',
            attributes: Object.assign(Object.assign({}, baseDefault), { color: designToken('text-warning-02'), 'background-color': designToken('warning-03') }),
        },
        {
            name: 'counter-danger',
            attributes: Object.assign(Object.assign({}, badgeCounterDefault), { 'background-color': quickProperty('var(--goto-badge-background-color, var(--goto-danger-01))'), color: quickProperty('var(--goto-badge-color, var(--goto-text-04))') }),
        },
        {
            name: 'counter-secondary',
            attributes: Object.assign(Object.assign({}, badgeCounterDefault), { 'background-color': quickProperty('var(--goto-badge-background-color, var(--goto-neutral-03))'), color: quickProperty('var(--goto-badge-color, var(--goto-text-01))') }),
        },
        {
            name: 'dot',
            attributes: {
                padding: quickProperty('0'),
                height: designToken('spacing-03'),
                width: designToken('spacing-03'),
                'min-height': designToken('spacing-03'),
                'min-width': designToken('spacing-03'),
            },
        },
        {
            name: 'dot-small',
            attributes: {
                padding: quickProperty('0'),
                height: quickProperty('8px'),
                width: quickProperty('8px'),
                'min-height': quickProperty('8px'),
                'min-width': quickProperty('8px'),
            },
        },
    ],
};
